import Vue from 'vue';
import VueSocialSharing from 'vue-social-sharing';

// Initialize VueSocialSharing and set custom sharing networks if specified
Vue.use(VueSocialSharing, [{"networks":{"instagram":"https:\u002F\u002Fwww.instagram.com\u002Fsharer\u002Fsharer.php??url=@url&title=@title"}}][0]);
